export var getFooterMenuItems = function getFooterMenuItems(categories) {
  return categories.map(function (category) {
    return {
      items: category.groups.map(function (group) {
        var _group$viewAllLink, _group$viewAllLink2;

        return {
          items: group.items.map(function (item) {
            return {
              label: item === null || item === void 0 ? void 0 : item.title,
              href: item === null || item === void 0 ? void 0 : item.path
            };
          }),
          showAllLink: group.viewAllLink ? {
            href: (_group$viewAllLink = group.viewAllLink) === null || _group$viewAllLink === void 0 ? void 0 : _group$viewAllLink.path,
            label: (_group$viewAllLink2 = group.viewAllLink) === null || _group$viewAllLink2 === void 0 ? void 0 : _group$viewAllLink2.title
          } : null
        };
      }),
      label: category.title
    };
  });
};